import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_ESTIMATE_TEMPLATES: createSagaAction('GET_ESTIMATE_TEMPLATES'),
  GET_TEMPLATE_SECTIONS: createSagaAction('GET_TEMPLATE_SECTIONS'),
  GET_TEMPLATE_ITEMS: createSagaAction('GET_TEMPLATE_ITEMS')
}

// Action Creators
export const actions = {
  getEstimateTemplates: () => ({
    type: constants.GET_ESTIMATE_TEMPLATES.ACTION
  }),

  getTemplateSections: templateId => ({
    type: constants.GET_TEMPLATE_SECTIONS.ACTION,
    templateId
  }),

  getTemplateItems: templateId => ({
    type: constants.GET_TEMPLATE_ITEMS.ACTION,
    templateId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_ESTIMATE_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ESTIMATE_TEMPLATES.SUCCESS:
      return {
        ...state,
        estimateTemplates: action.payload
      }
    case constants.GET_TEMPLATE_SECTIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_TEMPLATE_SECTIONS.SUCCESS:
      return {
        ...state,
        templateSections: action.payload
      }
    case constants.GET_TEMPLATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_TEMPLATE_ITEMS.SUCCESS:
      return {
        ...state,
        templateItems: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/estimateTemplateActions.js